"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--right/16"));
var _CurrencyFormatter = _interopRequireDefault(require("../../../common/Formatters/CurrencyFormatter"));
var _statusEnum = require("../../../common/statusEnum");
var _StatusIcon = require("../../StatusIcon/StatusIcon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ExpansionArea = props => /*#__PURE__*/_react.default.createElement("button", props);
const AccordionFIBUItem = _ref => {
  let {
    index,
    isOpen,
    title,
    tooltip,
    total,
    allRowsFilled,
    className,
    children
  } = _ref;
  const [open, setOpen] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setOpen(isOpen);
  }, [isOpen]);
  const handleHeadingClick = e => {
    setOpen(!open);
  };
  const handleKeyDown = e => {
    if (e.key === 'Escape' && open && e.target.classList.contains('bx--accordion__heading')) {
      handleHeadingClick(e);
    }
  };
  const status = allRowsFilled ? _statusEnum.statuses.COMPLETE : _statusEnum.statuses.INPROGRESS;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)({
      ['bx--accordion__item--active']: open
    }, {
      ['remove-top-border']: index === 0
    }, 'bx--accordion__item', className),
    onKeyDown: handleKeyDown
  }, /*#__PURE__*/_react.default.createElement(ExpansionArea, {
    type: "button",
    "aria-expanded": open,
    className: "bx--accordion__heading ",
    onClick: handleHeadingClick,
    title: ''
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--accordion__title sia-text-07"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "expansion-total"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_StatusIcon.StatusIcon, {
    status: status
  })), /*#__PURE__*/_react.default.createElement("p", null, _CurrencyFormatter.default.formatAlternate(total, total < 9999999 ? 'CHF' : '')), /*#__PURE__*/_react.default.createElement(_.default, {
    focusable: "false",
    className: "bx--accordion__arrow",
    "aria-label": "Open/Close Button"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--accordion__content"
  }, tooltip && /*#__PURE__*/_react.default.createElement("p", {
    className: "bx--accordion__tooltip sia-padding-02-bottom "
  }, tooltip), children));
};
var _default = exports.default = AccordionFIBUItem;